<template>
  <chart class="qj-echarts" ref="chart" :options="options"></chart>
</template>

<script>
import moment from "moment";

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      defaultOptions: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          data: ["Acionáveis", "Não acionáveis"],
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [],
            axisLabel: {
              lineHeight: 13,
              fontSize: 9,
              rotate: 40,
              showMinLabel: true,
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "Acionáveis",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [],
          },
          {
            name: "Não acionáveis",
            type: "line",
            stack: "Total",
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [],
          },
        ],
      },
    };
  },
  computed: {
    options() {
      if (!this.data.length) return this.defaultOptions;
      return this.renderChart();
    },
  },
  methods: {
    renderChart() {
      let options = { ...this.defaultOptions };
      options.series[0].data = [];
      options.series[1].data = [];
      options.xAxis[0].data = [];

      this.data.forEach((node) => {
        options.series[0].data.push(node.not_located_approachable);
        options.series[1].data.push(node.not_located_not_approachable);
        options.xAxis[0].data.push(moment(node.created_at).format("DD/MM"));
      });
      return options;
    },
  },
};
</script>

<style></style>
